import httpClient from '@/shared/http-tms-client';

const getMunicipalities = () => httpClient.get('/municipality');

const getTMSAddresses = () => httpClient.get('/address');

const getMyRecords = (email, ownerId, ownerContactId) => httpClient.get(`/Permit/MyRecords?useremail=${email}&ownerId=${ownerId}&ownerContactId=${ownerContactId}`);

const getPermitPDF = (userId, accessToken, documentId) => httpClient.get(`/Permit/OpenDocument?userId=${userId}&securitytoken=${accessToken}&documentId=${documentId}`);

const updateCertificate = (siteRegistrationID) => httpClient.post(`/SiteRegistration/UpdateCertificate?siteRegistrationID=${siteRegistrationID}`);
// eslint-disable-next-line import/prefer-default-export
export {
  getMunicipalities,
  getTMSAddresses,
  getMyRecords,
  getPermitPDF,
  updateCertificate,
};
